export default __webpack_public_path__ + "static/media/feature_04.61734515.svg";